export default __webpack_public_path__ + "static/media/ordericon.e3506871.svg";